// schemas/configImpostosSchema.ts
import * as yup from "yup";

export const configImpostosSchema = yup.object({
  id_configuracao: yup.string().nullable(),
  id_pis: yup.string().nullable(),
  id_inss: yup.string().nullable(),
  id_iss: yup.string().nullable(),
  id_ir: yup.string().nullable(),
  id_fgts: yup.string().nullable(),
  id_fgts_13: yup.string().nullable(),
  id_inss_13: yup.string().nullable(),
});
